// @file CommandBar callback functions used in actions
import { navigateToPadletMiniStoreURL } from '@@/bits/command_bar/tours/padlet_mini_5/actions'
import { convertWallToTableFormat, revertWallConversion } from '@@/bits/command_bar/tours/table_format_release/actions'
import { captureException } from '@@/bits/error_tracker'
import { isAppUsing } from '@@/bits/flip'
import window from '@@/bits/global'

// note: to link these callbacks with app.commandbar.com, go to https://app.commandbar.com/editor/actions
// click your action, and set the Callback key to the respective key in this object.
const COMMAND_AI_CALLBACKS = {
  // table format release
  convert_wall_to_table: convertWallToTableFormat,
  undo_wall_conversion: revertWallConversion,
  // padlet mini
  navigate_to_padlet_mini_store_url: navigateToPadletMiniStoreURL,
} as const

/**
 * Registers CommandBar callbacks for AI-related actions.
 * This function adds callbacks that handle wall format conversion and reversion.
 * The callbacks are only registered if CommandBar is enabled and available.
 * Any errors during callback registration or execution are captured but not thrown.
 */
function addCommandAICallbacks(): void {
  if (!isAppUsing('commandBar') || window.CommandBar == null) return

  try {
    Object.entries(COMMAND_AI_CALLBACKS).forEach(([key, callback]) => {
      window.CommandBar.addCallback(key, () => {
        const result = callback()
        if (result && typeof result.then === 'function') {
          result.catch((error: unknown) => captureException(error))
        }
      })
    })
  } catch (error) {
    captureException(error)
  }
}
export { addCommandAICallbacks }
